// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-color[data-v-33c04df1]{background-color:var(--lms-tenant)!important}.vdatetime .vdatetime-input[data-v-33c04df1]{height:20px;border:1px solid #0ff!important}", ""]);
// Exports
module.exports = exports;
